<app-modal-header [modalTitle]="modalTitle" [showCloseBtn]="false"></app-modal-header>
<div class="repo-filters">
    <mat-form-field>
        <input
            matInput
            placeholder="Search by Plan Name/Season/User"
            #searchInput
            (input)="onRepoSearch(searchInput.value)"
        />
    </mat-form-field>
    <!-- <mat-form-field>
        <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusFilterChange()">
            <mat-option value="All">All</mat-option>
            <mat-option value="Draft">Draft</mat-option>
            <mat-option value="Submitted">Submitted</mat-option>
            <mat-option value="Approved">Approved</mat-option>
            <mat-option value="Rejected">Rejected</mat-option>
        </mat-select>
    </mat-form-field> -->
</div>
<div class="repo-grid">
    <ag-grid-angular
        id="reco-buy-qty-repo-grid"
        class="ag-theme-alpine ag-grid-container"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)"
        [loading]="loading"
    ></ag-grid-angular>
</div>
<app-confirm-popup #confirmPopupDelete (confirmModal)="onDeletePlan()"></app-confirm-popup>
<!-- Modal Footer -->
<app-modal-footer (closeModal)="ref.close()" [closeBtnText]="'Close'" [showUpdateBtn]="false"></app-modal-footer>
